import { createSlice } from "@reduxjs/toolkit";
import {
  fetchWarehouse,
  fetchWarehouseColumnDropdown,
  fetchWarehouseById,
  updateStatusInWarehouse,
  updateWarehouse,
  exportWarehouseCSV,
  updateStatusInWarehouseFiFo,
  getWarehouseByUser,
} from "./thunk";
interface WarehouseState {
  warehouseList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedOrganisation: any;
  orgDropDown: any[];
  industryTypeDropDown: any[];
  orgCityDropDown: any[];
  orgStateDropDown: any[];
  pincodeDropDown: any[];
  exportCSVLoading: boolean;
  exportCSVError: string | null;
  columnDropdowns: {
    [key: string]: string[];
  };
  warehouseByUserList: any;
  selectedWarehouse: any;
  warehouseByUserLoading: boolean;
}

const initialState: WarehouseState = {
  warehouseList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedOrganisation: null,
  orgDropDown: [],
  industryTypeDropDown: [],
  orgCityDropDown: [],
  orgStateDropDown: [],
  pincodeDropDown: [],
  exportCSVLoading: false,
  exportCSVError: null,
  columnDropdowns: {},
  warehouseByUserList: [],
  selectedWarehouse: null,
  warehouseByUserLoading: false,
};

export const warehouseSlice = createSlice({
  name: "warehouse",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWarehouse.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWarehouse.fulfilled, (state, action) => {
        state.loading = false;
        state.warehouseList = Array.isArray(action.payload.data)
          ? action.payload.data
          : [];
        state.rowCount =
          typeof action.payload.rowCount === "number"
            ? action.payload.rowCount
            : 0;
      })
      .addCase(fetchWarehouse.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch warehouse";
      })
      .addCase(fetchWarehouseById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWarehouseById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedOrganisation = action.payload;
      })
      .addCase(fetchWarehouseById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(updateWarehouse.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.warehouseList = state.warehouseList.map((wh) =>
          wh.id === action.payload.id ? action.payload : wh
        );
      })
      .addCase(updateWarehouse.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update warehouse";
      })
      .addCase(updateStatusInWarehouse.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.warehouseList = state.warehouseList.map((wh) =>
          wh.id === action.payload.id ? action.payload : wh
        );
      })
      .addCase(updateStatusInWarehouse.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update status";
      })
      .addCase(updateStatusInWarehouseFiFo.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.warehouseList = state.warehouseList.map((wh) =>
          wh.id === action.payload.id ? action.payload : wh
        );
      })
      .addCase(updateStatusInWarehouseFiFo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update status";
      })

      .addCase(fetchWarehouseColumnDropdown.fulfilled, (state, action) => {
        const { column, data } = action.payload;

        state.columnDropdowns[column] = data;
      })

      .addCase(exportWarehouseCSV.pending, (state) => {
        state.exportCSVLoading = true;
        state.exportCSVError = null;
      })
      .addCase(exportWarehouseCSV.fulfilled, (state) => {
        state.exportCSVLoading = false;
        state.exportCSVError = null;
      })
      .addCase(exportWarehouseCSV.rejected, (state, action) => {
        state.exportCSVLoading = false;
        state.exportCSVError =
          typeof action.payload === "string"
            ? action.payload
            : action.error.message || "Failed to export CSV";
      })
      .addCase(getWarehouseByUser.pending, (state, action) => {
        state.warehouseByUserLoading = true;
        state.error = null;
      })
      .addCase(getWarehouseByUser.fulfilled, (state, action) => {
        state.warehouseByUserLoading = false;
        state.warehouseByUserList = Array.isArray(action.payload.data)
          ? action.payload.data
          : [];
      })
      .addCase(getWarehouseByUser.rejected, (state, action) => {
        state.warehouseByUserLoading = false;
        state.error = action.error.message || "Failed to get warehouse";
      });
  },
});

export default warehouseSlice.reducer;
